import React from "react";
import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { SYSTEM_LANGUAGE_LABELS } from "../../shared/enums/shared-enums";
import { Work } from "../../types/work";
import WorkTable from "../../components/tables/WorkTable";

interface MainWorkPageProps {
  systemLanguageType: Work["system_language_type"];
}

const MainWorkPage: React.FC<MainWorkPageProps> = ({ systemLanguageType }) => {
  const navigate = useNavigate();
  const languageLabel = SYSTEM_LANGUAGE_LABELS[systemLanguageType];

  return (
    <Box>
      <Box
        sx={{
          mb: 4,
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          sx={{
            position: "absolute",
            left: 16,
          }}
          startIcon={<AddIcon />}
          onClick={() => navigate("create")}
        >
          Create Work
        </Button>

        <Typography variant="h1">
          {languageLabel ? `${languageLabel} Works` : "Works"}
        </Typography>
      </Box>
      <WorkTable filters={{ system_language_type: systemLanguageType }} />
    </Box>
  );
};

export default MainWorkPage;
